import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/Button';
import { CompanyWithOwnership } from 'types/company';

interface ViewCompanyModalProps {
  show: boolean;
  onHide: () => void;
  company: CompanyWithOwnership | null;
}

function ViewCompanyModal({ show, onHide, company }: ViewCompanyModalProps) {
  if (!company) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Company Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <strong>Name:</strong> {company.name}
          </div>
          <div>
            <strong>Description:</strong> {company.description || '-'}
          </div>
          <div>
            <strong>Address:</strong> {company.address || '-'}
          </div>
          <div>
            <strong>TIN:</strong> {company.tin || '-'}
          </div>
          <div>
            <strong>Tel:</strong> {company.tel || '-'}
          </div>
          <div>
            <strong>Email:</strong> {company.email || '-'}
          </div>
          <div>
            <strong>VAT Status:</strong> {company.vatStatus || '-'}
          </div>
          <div>
            <strong>Type of Entity:</strong> {company.entityType || '-'}
          </div>
          <div>
            <strong>Date of Registration:</strong>{' '}
            {company.registrationDate
              ? new Date(company.registrationDate).toLocaleDateString()
              : '-'}
          </div>
          <div>
            <strong>Registration Number:</strong>{' '}
            {company.registrationNumber || '-'}
          </div>
          <div>
            <strong>Trade Name:</strong> {company.tradeName || '-'}
          </div>
          <div>
            <strong>Business Style:</strong> {company.businessStyle || '-'}
          </div>
          <div>
            <strong>BMBE Registered:</strong> {company.isBmbe ? 'Yes' : 'No'}
          </div>
          <div>
            <strong>BMBE Registration No.:</strong>{' '}
            {company.bmbeRegistrationNumber || '-'}
          </div>
          <div>
            <strong>Fiscal Year Type:</strong>{' '}
            {company.fiscalYearType === 'custom'
              ? 'Custom Fiscal Year'
              : 'Calendar Year'}
          </div>
          <div>
            <strong>Fiscal Year Start:</strong>{' '}
            {company.fiscalYearStart
              ? new Date(company.fiscalYearStart).toLocaleDateString()
              : '-'}
          </div>
          <div>
            <strong>Fiscal Year End:</strong>{' '}
            {company.fiscalYearEnd
              ? new Date(company.fiscalYearEnd).toLocaleDateString()
              : '-'}
          </div>
          <div>
            <strong>Ownership:</strong> {company.owned ? 'Owner' : 'Member'}
          </div>
          <div>
            <strong>Created At:</strong>{' '}
            {new Date(company.createdAt).toLocaleString()}
          </div>
          <div>
            <strong>Updated At:</strong>{' '}
            {new Date(company.updatedAt).toLocaleString()}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ViewCompanyModal;
